// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/vendors." + "8d2a17591a2a02a93ba4" + ".js";
};